export const ORG_ROLE_OWNER = 'owner'
export const ORG_ROLE_ADMIN = 'admin'
export const ORG_ROLE_DEVELOPER = 'developer'
/** Stored as "member"; shown as Read-only. */
export const ORG_ROLE_MEMBER = 'member'

export function orgRoleLabel(role: string): string {
  switch (role) {
    case ORG_ROLE_OWNER:
      return 'Owner'
    case ORG_ROLE_ADMIN:
      return 'Admin'
    case ORG_ROLE_DEVELOPER:
      return 'Developer'
    case ORG_ROLE_MEMBER:
      return 'Read-only'
    default:
      return role
  }
}

export function canEditProjects(role: string): boolean {
  return role === ORG_ROLE_OWNER || role === ORG_ROLE_ADMIN
}

export function canEditDatabases(role: string): boolean {
  return canEditProjects(role)
}

export function canEditEnvironments(role: string): boolean {
  return canEditProjects(role) || role === ORG_ROLE_DEVELOPER
}

const ROLE_POWER_ORDER = [ORG_ROLE_OWNER, ORG_ROLE_ADMIN, ORG_ROLE_DEVELOPER, ORG_ROLE_MEMBER] as const

/** Roles the caller may grant on an API key: their own role and weaker. */
export function assignableOrgRoles(callerRole: string): string[] {
  const i = ROLE_POWER_ORDER.indexOf(callerRole as (typeof ROLE_POWER_ORDER)[number])
  if (i < 0) return [ORG_ROLE_MEMBER]
  return ROLE_POWER_ORDER.slice(i).slice()
}
